export enum AccountDropdownStateEnum {
  WALLET_DISCONNECTED = "disconnected",
  WALLET_CONNECTED = "connected",
  MMP_TRIGGERED = "mmpTriggered",
}
